export const UK_CAR_MAKES_WITH_MODELS = [
  {
    carMake: 'Abarth',
    carModels: [
      '500',
      '595',
      '695',
      '124 Spider',
      '500C',
      'Grande Punto',
      'Punto Evo',
    ],
  },
  { carMake: 'AC', carModels: ['302 and 212', 'Mamba'] },
  {
    carMake: 'Aixam',
    carModels: [
      '400 & 500',
      'A751',
      'cCity',
      'Crossline',
      'Crossover',
      'Roadline',
    ],
  },
  {
    carMake: 'Alfa Romeo',
    carModels: [
      '33',
      '75',
      '90',
      '145',
      '146',
      '147',
      '155',
      '156',
      '159',
      '164',
      '166',
      '4C',
      'Alfasud & Sprint',
      'Arna',
      'Brera',
      'Giulia',
      'Giulietta',
      'GT',
      'GTV',
      'Mito',
      'Spider',
      'Stelvio',
      'SZ',
      'Tonale',
    ],
  },
  { carMake: 'Alpine', carModels: ['A110'] },
  { carMake: 'Asia', carModels: ['Rocsta'] },
  {
    carMake: 'Aston Martin',
    carModels: [
      'Cygnet',
      'DB11',
      'DB7',
      'DB9',
      'DBS',
      'DBS Superleggera',
      'DBX',
      'Rapide',
      'V8',
      'Vanquish',
      'Vantage',
      'Virage',
    ],
  },
  {
    carMake: 'Audi',
    carModels: [
      '80',
      '90',
      '100',
      '200',
      'A1',
      'A2',
      'A3',
      'A4',
      'A5',
      'A6',
      'A7',
      'A8',
      'Cabriolet',
      'Coupe',
      'E-Tron',
      'E-Tron GT',
      'Q2',
      'Q3',
      'Q4 E-Tron',
      'Q5',
      'Q7',
      'Q8',
      'Q8 e-tron',
      'R8',
      'TT',
      'V8',
    ],
  },
  {
    carMake: 'Austin',
    carModels: ['Maestro', 'Metro', 'Mini', 'Montego'],
  },
  { carMake: 'BAC', carModels: ['Mono'] },
  {
    carMake: 'Bentley',
    carModels: [
      'Arnage',
      'Azure/Continental',
      'Bentayga',
      'Brooklands',
      'Continental Flying Spur',
      'Continental GT',
      'Corniche',
      'Eight',
      'Flying Spur',
      'Mulsanne',
      'Turbo R',
    ],
  },
  {
    carMake: 'BMW',
    carModels: [
      '1-Series',
      '2-Series',
      '330e',
      '3-Series',
      '4-Series',
      '5-Series',
      '6-Series',
      '7-Series',
      '8-Series',
      'Alpina',
      'i3',
      'i4',
      'i7',
      'i8',
      'iX',
      'iX1',
      'iX3',
      'X1',
      'X2',
      'X3',
      'X4',
      'X5',
      'X6',
      'X7',
      'XM',
      'Z1',
      'Z3',
      'Z4',
      'Z8',
    ],
  },
  {
    carMake: 'BMW Alpina',
    carModels: [
      'B3',
      'B4',
      'B5',
      'B6',
      'B7',
      'B8',
      'D3',
      'D4',
      'D5',
      'XB7',
      'XD3',
    ],
  },
  { carMake: 'Bristol', carModels: ['Blenheim', 'Fighter'] },
  {
    carMake: 'Cadillac',
    carModels: ['BLS', 'CTS', 'Escalade', 'Seville', 'SRX', 'STS', 'XLR'],
  },
  { carMake: 'Caterham', carModels: ['Super Seven'] },
  {
    carMake: 'Chevrolet',
    carModels: [
      'Aveo',
      'Blazer',
      'Camaro',
      'Captiva',
      'Corvette',
      'Cruze',
      'Epica',
      'Kalos',
      'Lacetti',
      'Matiz',
      'Orlando',
      'Spark',
      'Tacuma',
      'Trax',
      'Volt',
    ],
  },
  {
    carMake: 'Chrysler',
    carModels: [
      '300C',
      'Crossfire',
      'Delta',
      'Dodge Viper',
      'Grand Voyager',
      'Neon',
      'PT Cruiser',
      'Sebring',
      'Voyager',
      'Ypsilon',
    ],
  },
  {
    carMake: 'Citro\u00ebn',
    carModels: [
      '2CV6',
      'Ami',
      'AX',
      'Berlingo',
      'Berlingo Multispace',
      'BX',
      'C1',
      'C2',
      'C3',
      'C3 Aircross',
      'C3 Picasso',
      'C3 Pluriel',
      'C3 XTR',
      'C4',
      'C4 Cactus',
      'C4 Picasso',
      'C4 SpaceTourer',
      'C5',
      'C5 X',
      'C6',
      'C8',
      'C-Crosser',
      'CX',
      'C-Zero',
      'Dispatch Combi',
      'DS3',
      'DS4',
      'DS5',
      'e-Berlingo',
      'e-C4',
      'e-C4 X',
      'e-SpaceTourer',
      'Grand C4 Picasso',
      'Grand C4 SpaceTourer',
      'Nemo Multispace',
      'Saxo',
      'SpaceTourer',
      'Synergie',
      'Visa',
      'Xantia',
      'XM',
      'Xsara',
      'Xsara Picasso',
      'ZX',
    ],
  },
  {
    carMake: 'Coleman Milne',
    carModels: [
      'Dorchester',
      'Grosvenor',
      'Hearse',
      'Limousine',
      'Minster',
      'Windsor',
    ],
  },
  { carMake: 'Corvette', carModels: ['C6', 'Stingray'] },
  { carMake: 'Cupra', carModels: ['Ateca', 'Born', 'Formentor', 'Leon'] },
  {
    carMake: 'Dacia',
    carModels: ['Duster', 'Jogger', 'Logan', 'Sandero'],
  },
  {
    carMake: 'Daewoo',
    carModels: [
      'Espero',
      'Kalos',
      'Korando',
      'Lacetti',
      'Lanos',
      'Leganza',
      'Matiz',
      'Musso',
      'Nexia',
      'Nubira',
      'Tacuma',
    ],
  },
  {
    carMake: 'Daihatsu',
    carModels: [
      'Applause',
      'Charade',
      'Charmant',
      'Copen',
      'Cuore',
      'Domino',
      'Fourtrak',
      'Grand Move',
      'Materia',
      'Mira',
      'Move',
      'Sirion',
      'Sportrak',
      'Terios',
      'YRV',
    ],
  },
  { carMake: 'Daimler', carModels: ['Saloon', 'Super Eight'] },
  { carMake: 'De Tomaso', carModels: ['Guara'] },
  { carMake: 'DFSK', carModels: ['Glory'] },
  {
    carMake: 'Dodge',
    carModels: ['Avenger', 'Caliber', 'Journey', 'Nitro', 'Ram', 'SRT-10'],
  },
  {
    carMake: 'DS',
    carModels: [
      '3',
      '4',
      '5',
      '7',
      '9',
      '3 Crossback',
      '3 Crossback E-Tense',
      '3 E-Tense',
      '7 Crossback',
    ],
  },
  { carMake: 'Eagle', carModels: ['Hearse', 'Limousine'] },
  { carMake: 'Farbio', carModels: ['GTS'] },
  { carMake: 'FBS', carModels: ['Census'] },
  {
    carMake: 'Ferrari',
    carModels: [
      '308',
      '328',
      '348',
      '360',
      '412',
      '456',
      '458',
      '488',
      '512',
      '550',
      '575',
      '612',
      '400i',
      '599 GTB',
      '812 Superfast',
      'California',
      'California T',
      'Enzo',
      'F12berlinetta',
      'F355',
      'F40',
      'F430',
      'F50',
      'F512',
      'FF',
      'GTC4Lusso',
      'Mondial',
      'Portofino',
      'Testarossa',
    ],
  },
  {
    carMake: 'Fiat',
    carModels: [
      '126',
      '500',
      '124 Spider',
      '500 Electric',
      '500L',
      '500L MPW',
      '500X',
      'Barchetta',
      'Brava',
      'Bravo',
      'Cinquecento',
      'Coupe',
      'Croma',
      'Doblo',
      'Fiorino',
      'Grande Punto',
      'Idea',
      'Marea',
      'Multipla',
      'Panda',
      'Punto',
      'Punto Evo',
      'Qubo',
      'Regata',
      'Scudo',
      'Sedici',
      'Seicento',
      'Stilo',
      'Strada',
      'Tempra',
      'Tipo',
      'Ulysse',
      'Uno',
      'X1/9',
    ],
  },
  {
    carMake: 'Ford',
    carModels: [
      'B-MAX',
      'Capri',
      'C-MAX',
      'Cougar',
      'EcoSport',
      'Edge',
      'Escort',
      'Explorer',
      'Fiesta',
      'Focus',
      'Focus C-MAX',
      'Fusion',
      'Galaxy',
      'Granada',
      'Grand C-MAX',
      'Grand Tourneo Connect',
      'Ka',
      'Kuga',
      'Maverick',
      'Mondeo',
      'Mustang',
      'Mustang Mach-E',
      'Orion',
      'Probe',
      'Puma',
      'Scorpio',
      'Sierra',
      'Sierra Sapphire',
      'S-MAX',
      'StreetKa',
      'Tourneo Connect',
      'Tourneo Courier',
      'Transit Courier Kombi',
      'Transit Custom',
    ],
  },
  { carMake: 'FSO', carModels: ['1300', '1500 &125P', 'Caro', 'Polonez'] },
  {
    carMake: 'Genesis',
    carModels: ['G70', 'G80', 'GV60', 'GV70', 'GV80'],
  },
  { carMake: 'GWM ORA', carModels: ['Funky Cat'] },
  {
    carMake: 'Honda',
    carModels: [
      'Accord',
      'Ballade',
      'Civic',
      'Concerto',
      'CR-V',
      'CRX',
      'CR-Z',
      'e',
      'FR-V',
      'HR-V',
      'Insight',
      'Integra',
      'Integra Type-R',
      'Jazz',
      'Legend',
      'Logo',
      'NSX',
      'Prelude',
      'S2000',
      'Shuttle',
      'Stream',
    ],
  },
  { carMake: 'Hummer', carModels: ['H2', 'H3'] },
  {
    carMake: 'Hyundai',
    carModels: [
      'Accent',
      'Amica',
      'Atoz',
      'Bayon',
      'Coupe',
      'Elantra',
      'Genesis',
      'Getz',
      'Grandeur',
      'i10',
      'i20',
      'i30',
      'i40',
      'i800',
      'Ioniq',
      'Ioniq 5',
      'Ioniq 6',
      'Ioniq Electric',
      'ix20',
      'ix35',
      'Kona',
      'Kona Electric',
      'Lantra',
      'Matrix',
      'Pony',
      'Pony X2',
      'Santa Fe',
      'S-Coupe',
      'Sonata',
      'Stellar',
      'Terracan',
      'Trajet',
      'Tucson',
      'Veloster',
      'XG30',
    ],
  },
  { carMake: 'INEOS', carModels: ['Grenadier'] },
  {
    carMake: 'Infiniti',
    carModels: ['EX', 'FX', 'G', 'M', 'Q30', 'Q50', 'Q60', 'QX30'],
  },
  { carMake: 'Invicta', carModels: ['S1'] },
  { carMake: 'Isuzu', carModels: ['Piazza', 'Trooper'] },
  {
    carMake: 'Jaguar',
    carModels: [
      'E-Pace',
      'F-Pace',
      'F-Type',
      'I-Pace',
      'S-Type',
      'XE',
      'XF',
      'XJ',
      'XJS',
      'XJSC',
      'XK',
      'XK8',
      'X-Type',
    ],
  },
  {
    carMake: 'Jeep',
    carModels: [
      'Avenger',
      'Cherokee',
      'Commander',
      'Compass',
      'Grand Cherokee',
      'Patriot',
      'Renegade',
      'Wrangler',
      'Wrangler Unlimited',
    ],
  },
  { carMake: 'Jensen', carModels: ['SV8'] },
  {
    carMake: 'Kia',
    carModels: [
      'Carens',
      'Ceed',
      'Cerato',
      'Clarus',
      'e-Niro',
      'EV6',
      'Magentis',
      'Mentor',
      'Niro',
      'Niro EV',
      'Optima',
      'Picanto',
      'Pride',
      'ProCeed',
      'Rio',
      'Sedona',
      'Shuma',
      'Shuma II',
      'Sorento',
      'Soul',
      'Soul EV',
      'Sportage',
      'Stinger',
      'Stonic',
      'Venga',
      'Xceed',
    ],
  },
  { carMake: 'KTM', carModels: ['X-Bow'] },
  { carMake: 'Lada', carModels: ['Niva', 'Riva', 'Samara'] },
  {
    carMake: 'Lamborghini',
    carModels: [
      'Aventador',
      'Diablo',
      'Gallardo',
      'Huracan',
      'Murcielago',
      'Urus',
    ],
  },
  {
    carMake: 'Lancia',
    carModels: [
      'Beta',
      'Dedra',
      'Delta',
      'Monte Carlo',
      'Prisma',
      'Thema',
      'Y10',
    ],
  },
  {
    carMake: 'Land Rover',
    carModels: [
      'Defender',
      'Discovery',
      'Discovery Sport',
      'Freelander',
      'Range Rover',
      'Range Rover Evoque',
      'Range Rover Sport',
      'Range Rover Velar',
    ],
  },
  { carMake: 'LEVC', carModels: ['TX'] },
  {
    carMake: 'Lexus',
    carModels: [
      'CT',
      'ES',
      'GS',
      'IS',
      'LC',
      'LS',
      'NX',
      'RC',
      'RX',
      'RZ',
      'SC',
      'UX',
      'UX Electric',
    ],
  },
  { carMake: 'Ligier', carModels: ['Ambra', 'Nova'] },
  {
    carMake: 'Lotus',
    carModels: [
      '2-Eleven',
      'Elan',
      'Eletre',
      'Elise',
      'Elise 340R',
      'Emira',
      'Esprit',
      'Europa',
      'Evora',
      'Excel',
      'Exige',
    ],
  },
  { carMake: 'LTI', carModels: ['TX4', 'TXII'] },
  { carMake: 'MAHINDRA', carModels: ['e2o'] },
  {
    carMake: 'Marcos',
    carModels: ['LM', 'Manta Ray', 'Mantara', 'Mantis', 'TSO'],
  },
  {
    carMake: 'Marlin',
    carModels: ['5EXI', 'Hunter', 'Makaira', 'Sportster Toi'],
  },
  {
    carMake: 'Maserati',
    carModels: [
      '222',
      '430',
      '3200 GT',
      'Coupe',
      'Ghibli',
      'Gran Cabriolet',
      'Gransport',
      'GranTurismo',
      'Grecale',
      'Levante',
      'MC20',
      'Quattroporte',
      'Shamal',
      'Spyder',
    ],
  },
  { carMake: 'MAXUS', carModels: ['MIFA 9'] },
  { carMake: 'Maybach', carModels: ['57', '62'] },
  {
    carMake: 'Mazda',
    carModels: [
      '2',
      '3',
      '5',
      '6',
      '121',
      '323',
      '626',
      '929',
      'CX-3',
      'CX-30',
      'CX-5',
      'CX-60',
      'CX-7',
      'Demio',
      'MPV',
      'MX-3',
      'MX-30',
      'MX-5',
      'MX-6',
      'Premacy',
      'RX-7',
      'RX-8',
      'Tribute',
      'Xedos 6',
      'Xedos 9',
    ],
  },
  {
    carMake: 'McLaren',
    carModels: [
      '540C',
      '570GT',
      '570S',
      '600LT',
      '620R',
      '650S',
      '650S Spider',
      '675LT',
      '720S',
      '765LT',
      'Artura',
      'GT',
      'P1',
      'Senna',
    ],
  },
  {
    carMake: 'Mercedes-AMG',
    carModels: ['A 45', 'C-Class', 'CLA', 'E-Class', 'EQE', 'GLE', 'GT', 'SL'],
  },
  {
    carMake: 'Mercedes-Benz',
    carModels: [
      '190 Series',
      '200-300 W123 Series',
      'A-Class',
      'AMG GT',
      'B-Class',
      'C-Class',
      'CE-Class',
      'CL',
      'CLA',
      'CLA-Class',
      'CLC',
      'CLK',
      'CLS',
      'E-Class',
      'EQA',
      'EQB',
      'EQC',
      'EQE',
      'EQS',
      'EQV',
      'G-Class',
      'GLA-Class',
      'GLB',
      'GLC',
      'GLC-Class',
      'GL-Class',
      'GLE',
      'GLE-Class',
      'GLS',
      'GLS-Class',
      'G-Wagen',
      'M-Class',
      'R-Class',
      'S-Class',
      'SEC',
      'SLC-Class',
      'SL-Class',
      'SLK',
      'SLS-Class',
      'Vaneo',
      'V-Class',
      'Viano',
    ],
  },
  {
    carMake: 'MG',
    carModels: [
      'F',
      'GS',
      'HS',
      'MG4',
      'MG5 EV',
      'RV8',
      'SV',
      'TF',
      'ZR',
      'ZS',
      'ZS EV',
      'ZT',
    ],
  },
  { carMake: 'MG Motor UK', carModels: ['Magnette', 'MG3', 'MG6', 'TF'] },
  { carMake: 'MIA', carModels: ['C', 'L'] },
  {
    carMake: 'Microcar',
    carModels: ['M8', 'MC1/MC2', 'M-Go', 'Practic', 'Virgo'],
  },
  {
    carMake: 'MINI',
    carModels: [
      'Clubman',
      'Convertible',
      'Cooper S',
      'Countryman',
      'Coupe',
      'Electric Hatch',
      'Hatchback',
      'John Cooper Works',
      'Paceman',
      'Roadster',
    ],
  },
  {
    carMake: 'Mitsubishi',
    carModels: [
      '3000 GT',
      'ASX',
      'Carisma',
      'Colt',
      'Cordia',
      'Eclipse Cross',
      'FTO',
      'Galant',
      'Grandis',
      'i',
      'i-MiEV',
      'Lancer',
      'Lancer Evo',
      'Mirage',
      'Outlander',
      'Sapporo',
      'Shogun',
      'Shogun Pinin',
      'Shogun Sport',
      'Sigma',
      'Space Runner',
      'Space Star',
      'Space Wagon',
      'Starion',
      'Tredia',
    ],
  },
  { carMake: 'MOKE', carModels: ['Moke'] },
  {
    carMake: 'Morgan',
    carModels: [
      '3 Wheeler',
      'Aero 8',
      'Aero Coupe',
      'Aero Supersports Tourer',
      'Four-Four & Plus Four',
      'Plus Eight',
      'Plus Four',
      'Plus Six',
      'Roadster',
    ],
  },
  {
    carMake: 'Nissan',
    carModels: [
      '100 NX',
      '200 SX',
      '280C & 300C',
      '300 ZX',
      '350Z',
      '370Z',
      'Almera',
      'Almera Tino',
      'Ariya',
      'Bluebird',
      'Cherry',
      'Cube',
      'GT-R',
      'Juke',
      'Laurel',
      'Leaf',
      'Maxima',
      'Maxima QX',
      'Micra',
      'Murano',
      'Note',
      'NV200 Combi',
      'Pathfinder',
      'Patrol',
      'Pixo',
      'Prairie',
      'Primera',
      'Pulsar',
      'Qashqai',
      'Qashqai+2',
      'QX',
      'Serena',
      'Silvia',
      'Skyline R33',
      'Skyline R34',
      'Stanza',
      'Sunny',
      'Terrano',
      'X-Trail',
    ],
  },
  { carMake: 'Noble', carModels: ['M12'] },
  { carMake: 'Opel', carModels: ['Manta', 'Monza'] },
  { carMake: 'Perodua', carModels: ['Kelisa', 'Kenari', 'Myvi', 'Nippa'] },
  {
    carMake: 'Peugeot',
    carModels: [
      '106',
      '107',
      '108',
      '205',
      '206',
      '207',
      '208',
      '305',
      '306',
      '307',
      '308',
      '309',
      '405',
      '406',
      '407',
      '408',
      '505',
      '508',
      '605',
      '607',
      '806',
      '807',
      '1007',
      '2008',
      '3008',
      '4007',
      '5008',
      'Bipper Tepee',
      'e-2008',
      'e-208',
      'e-Rifter',
      'e-Traveller',
      'Expert Combi',
      'Expert Tepee',
      'Ion',
      'Partner Combi',
      'Partner Tepee',
      'RCZ',
      'Rifter',
      'Traveller',
    ],
  },
  { carMake: 'PGO', carModels: ['Cevennes', 'Speedster II'] },
  { carMake: 'Polestar', carModels: ['1', '2', '3'] },
  {
    carMake: 'Porsche',
    carModels: [
      '911',
      '924',
      '928',
      '944',
      '968',
      '718 Boxster',
      '718 Cayman',
      'Boxster',
      'Cayenne',
      'Cayman',
      'Macan',
      'Panamera',
      'Taycan',
    ],
  },
  { carMake: 'PRINDIVILLE', carModels: ['Hummer'] },
  {
    carMake: 'Proton',
    carModels: [
      'Compact',
      'Coupe',
      'Exora',
      'GEN-2',
      'Impian',
      'Mpi',
      'Persona',
      'Preve',
      'Satria',
      'Satria Neo',
      'Savvy',
      'Wira',
    ],
  },
  { carMake: 'Reliant', carModels: ['Robin & Rialto', 'Scimitar', 'SSI'] },
  {
    carMake: 'Renault',
    carModels: [
      '4',
      '5',
      '9',
      '11',
      '18',
      '19',
      '21',
      '25',
      'Arkana',
      'Avantime',
      'Captur',
      'Clio',
      'Espace',
      'Fluence',
      'Grand Espace',
      'Grand Modus',
      'Grand Scenic',
      'GTA & A610',
      'Kadjar',
      'Kangoo',
      'Koleos',
      'Laguna',
      'Megane',
      'Megane E-Tech',
      'Megane Scenic',
      'Modus',
      'Safrane',
      'Scenic',
      'Sport Spider',
      'Twingo',
      'Twizy',
      'Vel Satis',
      'Wind',
      'Zoe',
    ],
  },
  {
    carMake: 'Rolls-Royce',
    carModels: [
      'Camargue',
      'Corniche',
      'Cullinan',
      'Dawn',
      'Ghost',
      'Limousine (Park Ward)',
      'Phantom',
      'Silver Dawn',
      'Silver Seraph',
      'Silver Shadow',
      'Silver Spirit',
      'Silver Spur',
      'Silver Wraith',
      'Wraith',
    ],
  },
  {
    carMake: 'Rover',
    carModels: [
      '25',
      '45',
      '75',
      '100',
      '200',
      '400',
      '600',
      '800',
      'CityRover',
      'Metro',
      'Mini',
      'Sd1',
      'Streetwise',
    ],
  },
  { carMake: 'Saab', carModels: ['900', '9000', '9-3', '9-5'] },
  { carMake: 'San', carModels: ['Storm'] },
  { carMake: 'SAO', carModels: ['Penza'] },
  {
    carMake: 'SEAT',
    carModels: [
      'Alhambra',
      'Altea',
      'Arona',
      'Arosa',
      'Ateca',
      'Cordoba',
      'Exeo',
      'Ibiza',
      'Leon',
      'Malaga',
      'Marbella',
      'Mii',
      'Mii Electric',
      'Tarraco',
      'Terra Vista',
      'Toledo',
    ],
  },
  {
    carMake: 'Skoda',
    carModels: [
      'Citigo',
      'Citigo-e',
      'Enyaq',
      'Estelle',
      'Fabia',
      'Favorit',
      'Felicia',
      'Kamiq',
      'Karoq',
      'Kodiaq',
      'Octavia',
      'Rapid',
      'Roomster',
      'Scala',
      'Superb',
      'Yeti',
    ],
  },
  {
    carMake: 'Smart',
    carModels: [
      'City',
      'Crossblade',
      'EQ Forfour',
      'EQ Fortwo',
      'Forfour',
      'Fortwo',
      'Roadster',
    ],
  },
  {
    carMake: 'SsangYong',
    carModels: [
      'Korando',
      'Kyron',
      'Musso',
      'Rexton',
      'Rexton W',
      'Rodius',
      'Sports Pick-up',
      'Tivoli',
      'Tivoli XLV',
      'Turismo',
    ],
  },
  {
    carMake: 'Subaru',
    carModels: [
      '16 & 18',
      '1600 & 1800',
      'B9 Tribeca',
      'BRZ',
      'Forester',
      'Impreza',
      'Justy',
      'L Series',
      'Legacy',
      'Levorg',
      'Outback',
      'Solterra',
      'SVX',
      'Vivio',
      'WRX',
      'XT Turbo',
      'XV',
    ],
  },
  {
    carMake: 'Suzuki',
    carModels: [
      'Across',
      'Alto',
      'Baleno',
      'Cappuccino',
      'Celerio',
      'Grand Vitara',
      'Ignis',
      'Jimny',
      'Kizashi',
      'Liana',
      'S-Cross',
      'SJ',
      'Splash',
      'Swace',
      'Swift',
      'SX4',
      'SX4 S-Cross',
      'Vitara',
      'Wagon-R+',
      'X-90',
    ],
  },
  { carMake: 'Talbot', carModels: ['Samba'] },
  { carMake: 'Tata', carModels: ['Safari'] },
  { carMake: 'TD Cars', carModels: ['TD 2000'] },
  {
    carMake: 'Tesla',
    carModels: ['Model 3', 'Model S', 'Model X', 'Model Y', 'Roadster'],
  },
  {
    carMake: 'Toyota',
    carModels: [
      '4-Runner',
      'Auris',
      'Avensis',
      'Avensis Verso',
      'Aygo',
      'bZ4X',
      'Camry',
      'Carina',
      'Carina E',
      'Celica',
      'C-HR',
      'Corolla',
      'GR Supra',
      'GR86',
      'GT86',
      'Highlander',
      'IQ',
      'Land Cruiser',
      'Land Cruiser Amazon',
      'Land Cruiser Colorado',
      'Land Cruiser V8',
      'MR2',
      'Paseo',
      'Picnic',
      'Previa',
      'Prius',
      'Proace City Verso',
      'Raize',
      'RAV4',
      'Space Cruiser',
      'Starlet',
      'Supra',
      'Tercel',
      'Urban Cruiser',
      'Verso',
      'Yaris',
      'Yaris Cross',
    ],
  },
  {
    carMake: 'TVR',
    carModels: [
      'Cerbera',
      'Chimaera',
      'Griffith',
      'S',
      'Sagaris',
      'T350',
      'T400',
      'T440',
      'Tamora',
      'Tuscan',
      'Typhon',
      'V8',
    ],
  },
  {
    carMake: 'Vauxhall',
    carModels: [
      'Adam',
      'Agila',
      'Ampera',
      'Antara',
      'Astra',
      'Astra Belmont',
      'Calibra',
      'Carlton',
      'Cascada',
      'Cavalier',
      'Combo',
      'Combo Tour',
      'Combo-e Life',
      'Corsa',
      'Corsa-e',
      'Crossland',
      'Crossland X',
      'Frontera',
      'Grandland',
      'Grandland X',
      'Insignia',
      'Meriva',
      'Mokka',
      'Mokka-e',
      'Monaro',
      'Monterey',
      'Nova',
      'Omega',
      'Senator',
      'Signum',
      'Sintra',
      'Tigra',
      'Vectra',
      'Viva',
      'Vivaro',
      'Vivaro Life',
      'Vivaro Tourer',
      'Vivaro-e Life',
      'VX220',
      'VXR8',
      'Zafira',
    ],
  },
  {
    carMake: 'Volkswagen',
    carModels: [
      'Arteon',
      'Beetle',
      'Beetle Dune',
      'Bora',
      'Caddy',
      'Caddy Life',
      'Caddy Maxi',
      'Caddy Maxi Camper',
      'Caddy Maxi Life',
      'California',
      'Caravelle',
      'CC',
      'Corrado',
      'e-Golf',
      'Eos',
      'e-Up',
      'Fox',
      'Golf',
      'Grand California',
      'ID Buzz',
      'ID3',
      'ID4',
      'ID5',
      'Jetta',
      'Lupo',
      'Multivan',
      'Passat',
      'Phaeton',
      'Polo',
      'Scirocco',
      'Sharan',
      'Taigo',
      'T-Cross',
      'Tiguan',
      'Touareg',
      'Touran',
      'T-Roc',
      'Up',
      'Vento',
    ],
  },
  {
    carMake: 'Volvo',
    carModels: [
      '240',
      '340',
      '360',
      '440',
      '460',
      '480',
      '740',
      '760',
      '850',
      '940',
      '960',
      '260 Series',
      'C30',
      'C40',
      'C70',
      'EX90',
      'S40',
      'S60',
      'S70',
      'S80',
      'S90',
      'V40',
      'V50',
      'V60',
      'V70',
      'V90',
      'XC40',
      'XC40 Electric',
      'XC60',
      'XC70',
      'XC90',
    ],
  },
  { carMake: 'Westfield', carModels: ['Sei'] },
  {
    carMake: 'Yugo',
    carModels: ['311', '511 & 513', '45', '55', '65 & Tempo', 'Sana'],
  },
];

export const ukCarMakeToModels = UK_CAR_MAKES_WITH_MODELS.reduce(
  (acc, makeWithModels) => {
    acc[makeWithModels.carMake] = makeWithModels.carModels;
    return acc;
  },
  {} as Record<string, string[]>
);
